/*
 Тут хранятся признаки того, что прямо сейчас идёт ресайз, и счётчик его окончаний.
 Вынес отдельно, потому что про это должны знать сразу два места: тот, кто
 обрабатывает сам ресайз, и расчёт высот параметров в каждой строке.

 Ресайза два вида, и оба одинаково опасны для производительности при большом числе
 строк:
   - isColumnResizing  пользователь тянет границу колонки;
   - isWindowResizing   меняется размер окна/контейнера (окно, левая панель, девтулс).

 Пока идёт любой из них, высоты параметров не пересчитываем на каждом кадре, иначе
 при сотнях строк всё дико тормозит (тысячи замеров за кадр). Как только ресайз
 закончился, выключаем признак и увеличиваем счётчик - и строки один раз заново
 выравнивают высоты (счётчик входит в rowHeightAlignStamp).
*/

import { ref } from "vue";

export const isColumnResizing = ref<boolean>(false);
export const isWindowResizing = ref<boolean>(false);
export const resizeSettleCounter = ref<number>(0);

/* Таблица переведена на auto-раскладку из-за таскания границы колонки. Поднимается не
   при нажатии, а на первом движении мыши (когда реально готовим ширины). Нужен телу
   таблицы: пока флаг поднят, tableStyle держит table-layout: auto, иначе ре-рендер
   тела (его провоцирует замер высот виртуализатором при переносе текста) вернул бы
   таблицу в fixed - и содержимое стало бы обрезаться вместо переноса. */
export const isColumnDragLayoutAuto = ref<boolean>(false);

export function beginColumnResize(): void {
  isColumnResizing.value = true;
}

export function endColumnResize(): void {
  isColumnResizing.value = false;
  resizeSettleCounter.value++;
}

export function beginWindowResize(): void {
  isWindowResizing.value = true;
}

export function endWindowResize(): void {
  isWindowResizing.value = false;
  resizeSettleCounter.value++;
}
